import styles from "./styles/NotificationsIcon.module.scss";
import { observer } from "mobx-react";
import classNames from "classnames";
import { useStores } from "../../stores/useStores";

export const NotificationsIcon = observer((props: { className?: string }) => {
  const { userStore } = useStores();

  const iconClassName = classNames({
    [styles.notificationIcon]: true,
    [props.className || ""]: props.className,
  });

  if (userStore.unreadNotifications.total > 0) {
    const count =
      userStore.unreadNotifications.total > 9
        ? "9+"
        : userStore.unreadNotifications.total;
    return <span className={iconClassName}>{count}</span>;
  } else {
    return <span />;
  }
});
